<template>
    <div v-if="getColumnFilterType(column) === 'string'" class="text-filter row no-gutters align-end pl-1 pr-1" @click.stop>
        <div class="col-9">
            <ZSInput inputClass="full-width" @esc="onEsc"  @enter="onEnter" v-model="stringValue" label-color="black" label-size="80%"
                size="small" :label="''">
            </ZSInput>
        </div>
        <div class="col-1">
            <ZSButton class="text" size="small" icon="Close" color="danger" @click="emitFilterValue(true)"></ZSButton>
        </div>
    </div>
    <div v-if="getColumnFilterType(column) === 'list'" class="list-filter no-gutters row align-center" @click.stop>
        <div class="col-10">
            <div style="display: flex;align-items: center;padding-bottom: 0.5em;" class="filter-header">
                <!-- <div>{{ 'Filtro para :' + column.label }}</div> -->
                <ZSSelect class="block" 
                :items="column.filter.options || column.filter.items" 
                :placeholder="column.filter.placeholder || null" 
                :item-label="column.filter.optionLabel || 'label'" 
                :item-value="column.filter.optionValue || 'value'" 
                :item-key="column.filter.optionKey || 'label'" 
                v-model="listValue" 
                size="medium"
                @item-selected="onSelect">
                </ZSSelect>
            </div>
        </div>
        <div class="col-2">
            <ZSButton class="text" size="small" icon="Close" color="danger" @click="emitFilterValue(true)">
            </ZSButton>

        </div>
    </div>
    <div v-if="getColumnFilterType(column) === 'date'" class="date-filter gap-1 row align-end" @click.stop>
            <div style="display: flex;align-items: center;padding-bottom: 0.5em;" class="filter-header">
                <div>{{ 'Filtro para :' + column.label }}</div>
                <ZSButton class="text" size="small" icon="Close" color="danger" @click="emitFilterValue(true)">
                </ZSButton>
            </div>        
            <div style="padding:10px" class="picker-holder">
                <ZSSelect size="small" :show-dropdown-icon="false" style="width: 40px;" :items="dateOptions" item-value="value" v-model="dateOperator" >
                </ZSSelect>
                <ZSDatePicker v-model="dateValue"></ZSDatePicker>
                <ZSButton color="orange" size="small" @click="onDateFilter">Ok</ZSButton>
            </div>
    </div>
    <div v-if="getColumnFilterType(column) === 'numeric'" class="numeric-filter gap-1 row align-end" @click.stop>
            <div style="display: flex;align-items: center;padding-bottom: 0.5em;" class="filter-header">
                <div>{{ 'Filtro para :' + column.label }}</div>
                <ZSButton class="text" size="small" icon="Close" color="danger" @click="emitFilterValue(true)">
                </ZSButton>
            </div>        
            <div style="padding:10px" class="picker-holder">
                <ZSSelect size="small" :show-dropdown-icon="false" style="width: 40px;" :items="numericOptions" item-value="value" v-model="numericOperator" >
                </ZSSelect>
                <ZSInput type="number" v-model="numericValue" @esc="onEsc" @enter="onNumericFilter" size="small" placeholder="Valor"></ZSInput>
                <ZSButton color="orange" size="small" @click="onNumericFilter">Ok</ZSButton>
            </div>
    </div>
</template>

<script setup>
import { ref, watch } from 'vue'
import ZSList from '../ZSList.vue';
import ZSButton from '../../ZSButton.vue';
import ZSInput from '../../form/ZSInput.vue';
import ZSDatePicker from '../../form/ZSDatePicker.vue';
import ZSSelect from '../../form/ZSSelect.vue';




const props = defineProps({
    column: {
        type: Object,
        default: () => ({})
    },
    modelValue: {
        type: [String, Array, Object, Number],
        default: ''
    }
})

const emit = defineEmits(['update:modelValue', 'filter'])

const stringValue = ref('')
const listValue = ref([])
const dateValue = ref(null)
const dateOperator = ref("=")
const numericValue = ref('')
const numericOperator = ref("=")




const getColumnFilterType = (column) => {
    if (typeof column?.filter === 'string') {
        return 'string';
    } else if (column?.filter?.type) {
        return column.filter.type;
    } else {
        return 'string';
    }
}

// Initialize values from v-model
watch(() => props.modelValue, (newValue) => {
   
    if (getColumnFilterType(props.column) === 'string') {
        stringValue.value = newValue || ''
    } else if (getColumnFilterType(props.column) === 'list') {
        listValue.value = newValue
    } else if (getColumnFilterType(props.column) === 'numeric') {
        if (typeof newValue === 'object' && newValue !== null) {
            numericOperator.value = newValue.operator || '='
            numericValue.value = newValue.value || ''
        } else {
            numericValue.value = newValue || ''
        }
    }
}, { immediate: true })

const onEsc = () => {
    emitFilterValue(true)
}


const onEnter = (value) => {
    emitFilterValue()
}

const onSelect = (value) => {
    // alert(JSON.stringify(value))
    emit('update:modelValue', value)
    emit('filter', {
        column: props.column,
        label: value[`${props.column.filter.optionLabel || 'label'}`],
        value:value[`${props.column.filter.optionValue || 'value'}`],
        type: getColumnFilterType(props.column)
    })
}

const resetFilters = () =>{
    stringValue.value = '',
    listValue.value = []
    numericOperator.value ="="
    numericValue.newValue = ''
}

const emitFilterValue = (clear = false) => {
    let value

    if( clear) resetFilters()
    
    if (getColumnFilterType(props.column) === 'string') {
        value = stringValue.value
    } else if (getColumnFilterType(props.column) === 'list') {
        value = listValue.value.value
    } else if (getColumnFilterType(props.column) === 'numeric') {
   
            value = {
                operator: numericOperator.value,
                value: parseFloat(numericValue.value)
            }
    } else {
        value = stringValue.value
    }
    
    emit('update:modelValue', value)
    emit('filter', {
        column: props.column,
        value: clear ? "" : value,
        type: getColumnFilterType(props.column),
    })
}

const dateOptions = [
    {label:">",value:">"},
    {label:"<",value:"<"},
    {label:"=",value:"="},
    {label:">=",value:">="},
    {label:"<=",value:"<="}
]

const numericOptions = [
    {label:">",value:">"},
    {label:"<",value:"<"},
    {label:"=",value:"="},
    {label:">=",value:">="},
    {label:"<=",value:"<="}
]

const onDateFilter = () => {
    const filterValue = {
        operator: dateOperator.value,
        value: dateValue.value
    }
    emit('update:modelValue', filterValue)
    emit('filter', {
        column: props.column,
        value: filterValue
    })
}

const onNumericFilter = () => {
    if (numericValue.value === '' || numericValue.value === null) {
        emitFilterValue(true)
        return
    }
    
    const filterValue = {
        operator: numericOperator.value,
        value: parseFloat(numericValue.value)
    }
    emit('update:modelValue', filterValue)
    emit('filter', {
        column: props.column,
        value: filterValue
    })
}


</script>

<style scoped>
:root {
    /* Filter colors */
    --color-filter-text: #333;
    --color-filter-background: #FFFFFF;
    --color-filter-border: #e5e5e5;
    --color-filter-header-bg: #f5f5f5;
}
.date-filter 
.string-filter,
.list-filter,
.numeric-filter {
    display: flex;
    padding: 10px 20px;
    width: 650px;
    color: var(--color-filter-text, #333);
    font-weight: 400;
    ;
}

.text-filter{
    width: 200px;
}

.list-filter {
width: 300px;
}

.date-filter,
.numeric-filter {
width: 280px;
}

.filter-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px;
    /* background-color: var(--color-filter-header-bg, #f5f5f5); */
    color: var(--color-filter-text, #333);
    font-size: 14px;
    font-weight: 500;
}

.picker-holder {
    display: flex;
    align-items: center;
    padding: 5px;
    gap:4px;
}    


</style>